bam-cta-teaser-item {
  bam-richtext {
    p {
      text-align: center
    }

    ol,
    ul,
    .is-list,
    .list {
      text-align: center
    }

    &.is-left-aligned {
      p {
        text-align: left
      }

      ol,
      ul,
      .is-list,
      .list {
        text-align: left
      }

      .is-list {
        margin-left: 14px !important;
      }
    }
  }

  .cta-teaser-item__center-align {
    text-align: center
  }

  .cta-teaser-item__left-align {
    text-align: left
  }

  @media print {
    break-after: auto !important;

    bal-card {
      overflow: visible !important;
    }
  }
}

.cta-teaser-item__card {
  height: 100%;
  overflow: hidden;
}

.cta-teaser-item__container,
.cta-teaser-item__content-container {
  display: flex !important;
  flex-direction: column;
  height: 100%;
}

.cta-teaser-item__img-container {
  width: 100%;
}

.cta-teaser-item__content-container {
  text-align: center;
  align-items: center;

  // Break long words in headlines to prevent overflowing
  bal-heading {
    word-wrap: break-word;
    word-break: break-word;
  }
}

.cta-teaser-item__icon {
  width: 190px;
  margin: 0 auto;

  bam-image {
    width: 100%
  }
}

.cta-teaser-item__icon--is-multicol {
  min-height: 190px;
  display: flex;
  align-items: center;
}

.cta-teaser-item__image--is-multicol {
  min-height: 214px;
}

.cta-teaser-item__actions {
  @include mobile() {
    width: 100% !important;
  }
}


